<template lang='pug'>
  div
    app-header(:white='true' class='u-absolute')

    ul(class='u-white u-3/12 u-list-none c-service__wrapper u-show@tablet' id='menu')
      li(class='u-mb3'  v-for='serv in services')
        a(
          class='c-service', :style='{backgroundColor: serv.color}', :href="`#${serv.slug}`",
          :data-menuanchor='serv.slug', :class="{'not-selected' : `#${serv.slug}` !== $route.hash}") {{serv.name}}

          span(class='c-service__image u-icon service', :style='{color: serv.color}')

    div(id="fullpage")
      div(v-for='service in services' class='section u-flex u-items-center')
        figure(:style="{backgroundImage: 'url(' + service.background + ')'}" class='u-bg-image u-bg-opacity')
        div(class='o-wrapper u-flex u-justify-between u-items-center')
          ul(class='u-white u-3/12 u-list-none u-show@tablet')
          //- ul(class='u-white u-3/12 u-list-none menu')
          //-   li(class='u-mb3'  v-for='serv in services', :data-menuanchor='serv.slug')
          //-     a(class='c-service', :style='{backgroundColor: serv.color}', :href="`#${serv.slug}`") {{serv.name}}
          //-       span(class='c-service__image u-icon service', :style='{color: serv.color}')

          figure(class='u-4/12@tablet u-m0 u-px4 u-show@tablet')
            img(:src='service.imageUrl')

          div(class='u-5/12@tablet u-12/12 u-4/12@laptop')
            h2(class='u-fw-light u-fz-h1 u-white u-mt0') {{service.title}}
            //- p {{service.description}}
            div(v-html='service.description' class='u-white u-mb3')

            div(v-if='service.images.length > 0')
              button(class='u-inline-flex u-items-center u-mb4 c-btn--white' @click="showGallery('gallery' + service.id)")
                i(class='u-icon u-mr2') camera
                span(class='u-fw-s-bold') Ver galería de fotos

            div
              button(class='c-btn--primary u-7/12 u-inline-block u-fw-s-bold' @click='showModalService(service.id)') Pedir {{service.name}}

            div(v-viewer="options", :id="'gallery' + service.id")
              template(v-for="image in service.images")
                img(:data-source="image.url", :key="image.url", :src='image.urlThumb' class='u-hide')

    //- app-footer()

    modal-delivery(v-if='isShowModalDelivery' @hide='isShowModalDelivery = false' @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-express(v-if='isShowModalExpress' @hide='isShowModalExpress = false'  @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-radio-taxi(v-if='isShowModalRadioTaxi' @hide='isShowModalRadioTaxi = false'  @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-tourism(v-if='isShowModalTourism' @hide='isShowModalTourism = false'  @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-woman-taxi(v-if='isShowModalWomanTaxi' @hide='isShowModalWomanTaxi = false'  @success='isShowModalConfirm = true' @error='isShowModalError = true')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import ModalExpress from 'components/ModalExpress'
  import ModalDelivery from 'components/ModalDelivery'
  import ModalRadioTaxi from 'components/ModalRadioTaxi'
  import ModalTourism from 'components/ModalTourism'
  import ModalWomanTaxi from 'components/ModalWomanTaxi'

  export default {
    name: 'ServicesScreen',
    components: {
      ModalExpress,
      ModalWomanTaxi,
      ModalDelivery,
      ModalTourism,
      ModalRadioTaxi
    },
    data () {
      return {
        index: null,
        isShowModalConfirm: false,
        isShowModalError: false,
        isShowModalDelivery: false,
        isShowModalExpress: false,
        isShowModalRadioTaxi: false,
        isShowModalTourism: false,
        isShowModalWomanTaxi: false,
        selectedService: 0,
        services: [],
        options: {
          inline: false,
          button: true,
          navbar: true,
          title: false,
          toobar: false,
          tooltip: false,
          movable: false,
          zoomable: false,
          rotatable: false,
          scalable: false,
          transition: true,
          fullscreen: false,
          keyboard: true,
          url: 'data-source'
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      showGallery (gallery) {
        const viewer = this.$el.querySelector('#' + gallery).$viewer
        viewer.show()
      },

      getServices () {
        axios.get(`${window.API_URL}/services`)
          .then(({data}) => {
            this.services = data.data

            setTimeout(() => {
              let array = this.services.map((a) => {
                return a.slug
              })

              window.$('#fullpage').fullpage({
                anchors: array,
                // scrollBar: true,
                menu: '#menu'
              })
            }, 10)
          })
      },

      showModalService (id) {
        this.selectedService = id
        switch (id) {
          case 1:
            this.isShowModalWomanTaxi = true
            break
          case 2:
            this.isShowModalExpress = true
            break
          case 3:
            this.isShowModalTourism = true
            break
          case 4:
            this.isShowModalRadioTaxi = true
            break
          case 5:
            this.isShowModalDelivery = true
            break
          default:
        }
      }
    },

    beforeDestroy () {
      /* eslint-disable */
      $.fn.fullpage.destroy('all')
      /* eslint-enable */
    },

    created () {
      this.getServices()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Services/components/ServicesScreen.vue